import React, {useEffect, useState} from "react";
import {Loading} from "../../../common";
import {Box} from "@mui/system";
import {Grid} from "@mui/material";
import {formModes} from "../../../../_constants";
import {change, Field, reduxForm} from "redux-form";
import BasicFormTextField from "../../common/BasicFormTextField";
import {connect} from "react-redux";
import {isEmpty} from "lodash";
import {roleActions} from "../../../../_actions";
import moment from "moment/moment";
import AnchorButton from "../../common/AnchorButton";
import TimezonePickerComponent from "../Profile/Utilities/TimezonePicker";
import {isValidPassword} from "_helpers";
import SwitchComponent from "../../common/SwitchComponent";
import {pluck} from "underscore";
import BasicSelect from "../../common/BasicSelect";
import OrganizationSelect from "../../common/OrganizationSelect";
import ActionButton from "../../common/ActionButton";
import PasswordGroup from "./Utilities/PasswordGroup";
import moduleStyles from "./Utilities/Styles.module.css"

const UserForm = ({
                      dispatch,
                      handleSubmit,
                      initialize,
                      onSave,
                      cancelLink,
                      user,
                      mode,
                      roles,
                      pristine,
                      submitting,
                      loading
                  }) => {
    const [password, setPassword] = useState('')

    const fetchRoles = mode === formModes.ADD ||
        (mode === formModes.EDIT && isEmpty(user?._embedded?.roles));

    const hasNoOrganization = mode === formModes.ADD ||
        (mode === formModes.EDIT && isEmpty(user?._embedded?.organization));

    const handleRoleSelectChange = (value) => {
        dispatch(change('UserForm', 'role', value))
    }

    const handlePasswordChange = (value) => {
        dispatch(change('UserForm', 'password', value));
        setPassword(value)
    }

    const transformRoles = (roles) => roles.map(role => ({id: role.id, name: role.authority}))

    useEffect(() => {
        if (fetchRoles) {
            dispatch(roleActions.getAll());
        }

        initialize({
            ...user,
            password: '',
            dateCreated: moment(user?.dateCreated).format("MMMM D, YYYY"),
        });
    }, [dispatch, initialize, fetchRoles, user]);

    if (
        (mode === formModes.EDIT && !user) ||
        (fetchRoles && !roles)
    ) {
        return <Loading/>;
    }

    if (fetchRoles) {
        roles = transformRoles(roles.roles || [])
    }

    return (
        <Grid item xs={12} md={6}>
            <form
                name="form"
                onSubmit={handleSubmit(onSave)}
                autoComplete="off"
                className={moduleStyles.userFormContainer}
            >
                <Box sx={styles.header}>Edit User</Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>First Name</Box>
                    <Field
                        name="firstName"
                        component={BasicFormTextField}
                        placeholder={"Enter first name"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Last Name</Box>
                    <Field
                        name="lastName"
                        component={BasicFormTextField}
                        placeholder={"Enter last name"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Organization</Box>
                    <Field
                        name="organization"
                        component={OrganizationSelect}
                        placeholder={
                            hasNoOrganization
                                ? "User Organization"
                                : user._embedded.organization.name
                        }
                        input={{disabled: !hasNoOrganization}}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Role</Box>
                    <Field
                        name="role"
                        component={BasicSelect}
                        placeholder={fetchRoles ? 'User Role' : pluck(user._embedded.roles, 'authority').join(',')}
                        options={roles}
                        onChange={handleRoleSelectChange}
                        input={{disabled: !fetchRoles}}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Phone</Box>
                    <Field
                        name="phoneNumber"
                        component={BasicFormTextField}
                        placeholder={"Enter phone number"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Address</Box>
                    <Field
                        name="address"
                        component={BasicFormTextField}
                        placeholder={"Enter address"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Country</Box>
                    <Field
                        name="country"
                        component={BasicFormTextField}
                        placeholder={"Enter country"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>City</Box>
                    <Field
                        name="city"
                        component={BasicFormTextField}
                        placeholder={"Enter city"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>State</Box>
                    <Field
                        name="state"
                        component={BasicFormTextField}
                        placeholder={"Enter state"}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Email</Box>
                    <Field
                        name="username"
                        component={BasicFormTextField}
                        placeholder={"Enter email"}
                        disabled={mode === formModes.EDIT}
                    />
                </Box>
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Password</Box>
                    <PasswordGroup placeholder={"Enter new password"} value={password} handlePasswordChange={handlePasswordChange} />
                    
                </Box>
                <Box sx={styles.inputContainer} hidden>
                    <Box sx={styles.inputDesc}>Date Created</Box>
                    <Field name="dateCreated" component={BasicFormTextField} placeholder={'Date Created'}/>
                </Box>
                <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}} sx={styles.inputContainer}>
                    <Box sx={styles.inputDesc}>Timezone</Box>
                    <Field
                        name="timezone"
                        component={TimezonePickerComponent}
                    />
                </Box>
                <Box sx={styles.switchContainer}>
                    <Box sx={styles.inputDesc}>Locked</Box>
                    <Field
                        name="accountLocked"
                        component={SwitchComponent}
                    />
                </Box>
                <Box sx={styles.switchContainer}>
                    <Box sx={styles.inputDesc}>Enabled</Box>
                    <Field
                        name="enabled"
                        component={SwitchComponent}
                    />
                </Box>
                <Box sx={styles.actions}>
                    <Box sx={{width: "100px", marginRight: "18px"}}>
                        <ActionButton
                            label={"Save"}
                            disabled={pristine || submitting || loading || (password == '' ? false : !isValidPassword(password))}
                            withIcon={loading}
                        />
                    </Box>
                    <Box sx={{width: "100px", height: "40px"}}>
                        <AnchorButton
                            label={"Cancel"}
                            link={cancelLink}
                            buttonBordered={true}
                        />
                    </Box>
                </Box>
            </form>
        </Grid>
    );
}

const styles = {
    container: {
        background: "#FFF",
        fontFamily: 'FustatBold',
        border: '1px solid #CED4D4',
        borderRadius: '5px'
    },
    header: {
        borderBottom: '1px solid #CED4D4',
        padding: '15px 20px',
        fontSize: '18px',
        color: '#0C2728',
        mb: '15px'
    },
    inputContainer: {
        padding: '8px 20px'
    },
    switchContainer: {
        display: 'flex',
        alignItems: 'center',
        padding: '0px 20px',
        mt: '-12px',
        gap: '3px'
    },
    inputDesc: {
        fontSize: '14px',
        color: '#495D5E',
        mb: '7px'
    },
    actions: {
        display: 'flex',
        padding: '20px',
        mt: '15px'
    }
};

const mapStateToProps = (state) => {
    const {
        roles,
    } = state;
    return {
        roles: roles.roles,
    };
};

const userForm = connect(mapStateToProps)(reduxForm({
    form: "UserForm"
})(UserForm))

export {userForm as UserForm};
